import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {VapeRecordLogIntf}                              from '@djsharkk/logr-types';
import {ChartConfiguration, Point, TimeScaleOptions}    from 'chart.js';
import {AnnotationOptions}                              from 'chartjs-plugin-annotation';
import cloneDeep                                        from 'lodash/cloneDeep';
import {DateTime}                                       from 'luxon';
import {ChartLineComponent}                             from '../../comps/chart-line/chart-line.component';
import {ChartCatsBase}                                  from '../chart-cats.base';

@Component({
			   selector   : 'app-chart-vape-progression-day',
			   imports    : [
				   ChartLineComponent
			   ],
			   templateUrl: './chart-vape-progression-day.component.html',
			   styleUrl   : './chart-vape-progression-day.component.css'
		   })
export class ChartVapeProgressionDayComponent extends ChartCatsBase<ChartLineComponent, 'bar' | 'line'> implements OnDestroy, AfterViewInit {
	@ViewChild(ChartLineComponent) chartComponent!: ChartLineComponent;


	conf: ChartConfiguration<'line', Point[]> = {
		data   : {
			datasets: [
				{
					label      : 'Yesterday',
					data       : [],
					borderColor: 'rgba(255,255,255)',
					borderWidth: 1,
					pointRadius: 0,
					borderDash : [
						1,
						1
					]
				},
				{
					label      : 'Today',
					data       : [],
					borderColor: 'white',
					borderWidth: 1,
					pointRadius: 0
				}

			],
			labels  : []
		},
		options: cloneDeep(this.svcChartProps.optsHour),
		plugins: [],
		type   : 'line'
	};


	dateMin = DateTime.now().startOf('day')
	dateMax = DateTime.now().endOf('day')


	ngAfterViewInit(): void {


		const defaultScales = {
			...this.conf.options?.scales
		};

		const defaultY: TimeScaleOptions = {
			...defaultScales?.['y'] as TimeScaleOptions
		};
		const defaultX: TimeScaleOptions = {
			...defaultScales?.['x'] as TimeScaleOptions
		};

		if (this.conf.options?.plugins?.annotation?.annotations) {
			const annotations = this.conf.options.plugins.annotation.annotations as Record<string, AnnotationOptions>;
			if (annotations['now']) {
				annotations['now'].borderColor = 'white'
			}
		}

		if (this.conf.options?.scales) {
			if (this.conf.options.scales['x']) {
				this.conf.options.scales = {
					...defaultScales,
					x: {
						...defaultX,
						min  : this.dateMin.toMillis(),
						max  : this.dateMax.toMillis(),
						ticks: {
							...defaultX?.ticks,
							display: false
						}
					},
					y: {
						...defaultY,
						suggestedMax: 50,
						ticks       : {
							...defaultY?.ticks,
							display: false
						}
					}
				}

			}
		}

		const yesterday = DateTime.now().minus({day: 1}).startOf('day');
		this.svcDataFactory.svcDataVape.getRecordsLogDates([yesterday.toJSDate()])
			.subscribe((records) => {
				this.chartComponent?.updateDataset(
					0,
					{
						data: this.buildChart(records)
					}
				);
			});
		this.svcDataFactory.svcDataVape.getRecordsLogDates([new Date()])
			.subscribe((records) => {

				this.chartComponent?.updateDataset(
					1,
					{
						data: this.buildChart(records)
					}
				);
			});
	}

	buildChart(records: VapeRecordLogIntf[]) {
		return records.map((record, i) => ({
			x: this.svcChartDefaults.equaliseX(record.timestamp.toDate(), new Date()),
			y: records.slice(0, i + 1).reduce((sum, curr) => sum + curr.qtyMg, 0)
		}));
	}


}
